export const USER_INPUT_FIELD_TYPES = {
    PHONE: 'phone',
    EMAIL: 'email',
    EMAIL_OR_PHONE: 'emailOrPhone',
    FIRST_NAME: 'firstName',
    LAST_NAME: 'lastName',
    PASSWORD: 'password',
    CONFIRM_PASSWORD: 'confirmPassword',
    REQUIRED_FIELD: "requiredField",
    BOOLEAN_FIELD: 'booleanField',
    NUMBER_FIELD: "number",
    URL: "url",
    MIN_30_CHARACTORS: "min_30_char"
}